import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/no-unescaped-entities */
import { useEffect } from 'react';
import styled from 'styled-components';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import { fontSizes, spacing } from 'syf-component-library/defaultTheme';
import { Button } from 'syf-component-library/ui/atoms';
import { Grid } from 'syf-component-library/ui/patterns';
import { FooterContainer } from 'syf-component-library/ui/patterns/SlideInModal/subcomponents';
import { ModalFooter } from 'syf-component-library/ui/patterns/SlideInModalPortal';
import { Inset } from 'syf-component-library/ui/spacing';
import { DATA_ANALYTICS, DATA_OBJECT, DATA_REASON, DATA_TYPE, MESSAGE_TYPES, PAGE_FUNCTION, PAGE_NAME, SUB_FUNCTION } from '../../../../const/analytics';
import { closeImg } from '../../../../const/assets';
import MULTI_PAYMENT_FLOW_TABS from '../../../../const/multiPaymentFlowTabs';
import { useContextAtom } from '../../../../store/jotaiCoreAtoms';
import { useMultiPaymentReset, useShowCloseInterstitial } from '../../../../store/multiPaymentAtoms';
import { t } from '../../../../strings/i18n';
import IntroHeading from '../../../../ui/atoms/IntroHeading';
import { InterstitialContent, InterstitialWrapper } from './subcomponents';
const ImageWrapper = styled(Grid) `
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
export const ConfirmationImage = styled('img') `
  max-width: 100%;
  max-height: 100%;
`;
const Subtitle = styled(Inset) `
  padding: 0 0 ${spacing.large}px 0;

  @media ${mediaQueries.lessThanSmall} {
    padding-inline: 0px;
  }
`;
const OneTimePaymentButton = styled(Button) `
  font-size: ${fontSizes.root}px;
`;
const CloseInterstitial = ({ onAccept, onReject, onSwitchTab }) => {
    const [context] = useContextAtom();
    const [, setShowCloseConfirmationAtom] = useShowCloseInterstitial();
    const multiPaymentReset = useMultiPaymentReset();
    const handleAccept = () => {
        // clear all the multi payment state
        multiPaymentReset();
        onAccept();
    };
    const handleTabSwitch = () => {
        setShowCloseConfirmationAtom(false);
        onSwitchTab(MULTI_PAYMENT_FLOW_TABS.ONE_TIME);
    };
    useEffect(() => {
        const eventOptionsV1 = {
            messageType: MESSAGE_TYPES.DCH.SETTLEMENT_MULTI,
            pageFunction: PAGE_FUNCTION.MAKE_PAYMENT.PAYMENTS,
            pageSubFunction: SUB_FUNCTION.MAKE_PAYMENT.MULTI_PAYMENT,
            pageName: PAGE_NAME.MULTI_PAYMENT.EXIT_CONFIRMATION
        };
        context.triggerAnalyticsEvent(eventOptionsV1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsxs(InterstitialWrapper, { children: [_jsx(InterstitialContent, Object.assign({ bottom: "xlarge", hideOnBreakpointDown: "medium", vertical: "xxlarge" }, { children: _jsxs(ImageWrapper, Object.assign({ container: true }, { children: [_jsx(ConfirmationImage, { alt: "", "aria-hidden": "true", src: `${context.staticHostName}${closeImg}` }), _jsx(Inset, Object.assign({ horizontal: "large", vertical: "base" }, { children: _jsx(ImageWrapper, { children: _jsx(IntroHeading, Object.assign({ weight: "bold" }, { children: t('closeInterstitial.title') })) }) })), _jsx(Subtitle, { children: t('closeInterstitial.subtitle') }), t('closeInterstitial.oneTimePaymentQuestion'), _jsx(OneTimePaymentButton, Object.assign({ buttonType: "text", "data-analytics": DATA_ANALYTICS.CLICK_TRACKING_EVENT, "data-object": DATA_OBJECT.LINK, "data-reason": DATA_REASON.MULTI_PAYMENT.ONE_TIME_PAYMENT, "data-type": DATA_TYPE.MAKE_A_PAYMENT, onClick: handleTabSwitch }, { children: t('closeInterstitial.oneTimePaymentButton') }))] })) })), _jsx(FooterContainer, { children: _jsx(ModalFooter, { dataCy: "exit-interstitial-confirmation", dataPrimaryObject: DATA_OBJECT.BUTTON, dataPrimaryReason: "continue scheduling", dataSecondaryObject: DATA_OBJECT.BUTTON, dataSecondaryReason: "leave without scheduling", dataType: DATA_TYPE.MAKE_A_PAYMENT, handlePrimaryButton: onReject, handleSecondaryButton: handleAccept, primaryText: t('closeInterstitial.continueScheduling'), secondaryButtonType: "ghost", secondaryText: t('closeInterstitial.leaveWithoutScheduling') }) })] }));
};
export default CloseInterstitial;
